import * as download from 'downloadjs';
var DownloadHelper = /** @class */ (function () {
    function DownloadHelper() {
    }
    DownloadHelper.downloadFile = function (file) {
        var request = new XMLHttpRequest();
        request.open('GET', file.uri, true);
        request.responseType = 'blob';
        request.onload = function () {
            download(request.response, file.originName);
        };
        request.send();
    };
    return DownloadHelper;
}());
export default DownloadHelper;
